import React from "react";

export default ({ style, children }) => {
  return (
    <div
      style={Object.assign(
        {
          fontSize: 12,
          color: "rgba(33, 33, 33, 0.498039)",
          marginBottom: 5,
          marginTop: 10
        },
        style
      )}
    >
      {children}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/components/partials/label.jsx